import { render, staticRenderFns } from "./PurchaseReceiving.vue?vue&type=template&id=9d12267e"
import script from "./PurchaseReceiving.vue?vue&type=script&lang=js"
export * from "./PurchaseReceiving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d12267e')) {
      api.createRecord('9d12267e', component.options)
    } else {
      api.reload('9d12267e', component.options)
    }
    module.hot.accept("./PurchaseReceiving.vue?vue&type=template&id=9d12267e", function () {
      api.rerender('9d12267e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/secure/PurchaseReceiving.vue"
export default component.exports